import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ticketing-multi-step-progress-bar',
  imports: [CommonModule],
  templateUrl: './multi-step-progress-bar.component.html',
  styleUrl: './multi-step-progress-bar.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiStepProgressBarComponent {
  isError = input<boolean>(false);
  isSuccess = input<boolean>(false);
  steps = input.required<string[]>();
  currentProgress = input.required<number>();
}
